import { createSlice } from "@reduxjs/toolkit";

interface LoaderState {
    isLoader: boolean;
}

const initialState: LoaderState = {
    isLoader: false
};

const loaderSlice = createSlice({
    name: "loader",
    initialState,
    reducers: {
        showLoader: (state) => {
            state.isLoader = true;
        },

        hideLoader: (state) => {
            state.isLoader = false;
        }
    }
});

export const { showLoader, hideLoader } =
    loaderSlice.actions;

export default loaderSlice.reducer;